module.exports = __webpack_public_path__ + "img/icon-bx-user.ff4e1a8a.svg";